import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../../components/forms/Buttons/Button";
import Input from "../../../components/forms/Input/Input";
import CustomDialog from "../../../components/modals/CustomDialog/CustomDialog";

export default function RegionForm({
  isOpen,
  isEdit,
  formData,
  setFormData,
  onClose,
  onSubmit,
}) {
  const [t] = useTranslation();

  const handleClose = () => {
    setFormData({ name: "", team_limit: 80 });
    onClose();
  };

  return (
    <CustomDialog
      isOpen={isOpen}
      headerText={
        isEdit ? t("admin.edit_region") : t("admin.create_region")
      }
      closeModal={handleClose}
    >
      <div className="flex flex-col gap-4">
        <Input
          label={t("admin.region_name")}
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          required
        />
        <Input
          label={t("admin.team_limit")}
          type="number"
          disabled={true}
          value={formData.team_limit}
          onChange={(e) =>
            setFormData({ ...formData, team_limit: e.target.value })
          }
          required
        />
        <div className="flex justify-end gap-2">
          <Button text={t("buttons.cancel")} onClick={handleClose} />
          <Button
            text={isEdit ? t("buttons.update") : t("buttons.create")}
            onClick={onSubmit}
            color="primary"
          />
        </div>
      </div>
    </CustomDialog>
  );
}

